<template>
  <div class="list recruit-train-stat-page">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>招聘培训统计</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <div class="stat-toolbar">
        <DatePicker
          :value="dateRange"
          type="daterange"
          format="yyyy-MM-dd"
          :clearable="false"
          :disabled="searchLoading"
          transfer
          placeholder="选择日期范围"
          style="width: 220px;"
          @on-change="onDateRangeChange">
        </DatePicker>
        <span class="hr-label">统计模板</span>
        <Select
          v-model="statTemplate"
          transfer
          :disabled="searchLoading"
          style="width: 140px;"
          @on-change="onStatTemplateChange">
          <Option value="default">默认</Option>
          <Option value="agency">按中介</Option>
        </Select>
        <span class="hr-label">HR</span>
        <Select
          v-model="hr"
          placeholder="全部"
          clearable
          transfer
          :disabled="searchLoading"
          style="width: 140px;"
          @on-change="onHrChange">
          <Option v-for="item in $constant.hrList" :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
        <Button type="primary" :loading="searchLoading" style="margin-left: 12px;" @click="search">查询</Button>
        <Button type="primary" :loading="exportLoading" style="margin-left: 10px" @click="exportData">导出</Button>
      </div>
    </div>

    <div class="table-container">
      <div class="stat-formula">注册人数 = 待审核 + 已审核 + 培训中 + 培训淘汰 + 培训流失 + 在职人数 + 离职人数 + 已禁用</div>
      <Table :columns="summaryColumns" :data="summaryData" :loading="tableLoading" border stripe></Table>
    </div>
    <div class="table-container">
      <div class="table-title">按注册渠道</div>
      <Table ref="channelTable" :height="channelTableHeight" :columns="channelColumns" :data="channelTableData" :loading="tableLoading" :row-class-name="channelRowClassName" border stripe></Table>
    </div>

    <Modal v-model="detailVisible" :title="detailTitle" width="800">
      <Table :columns="detailColumns" :data="detailData" :loading="detailLoading" border stripe></Table>
      <div class="detail-page">
        <Page :total="detailTotal" :current="detailPageIndex" :page-size="detailPageSize"
              show-total show-sizer @on-change="onDetailPageChange" @on-page-size-change="onDetailPageSizeChange"></Page>
      </div>
      <div slot="footer">
        <Button type="primary" @click="detailVisible=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const STAT_COLUMNS = [
  {title: '注册人数', key: 'added', minWidth: 110, tip: '筛选时间范围内总注册人数'},
  {title: '待审核', key: 'pending', minWidth: 100, tip: '注册总人数中待审核人数，也就是老师管理/待审核老师'},
  {title: '已审核', key: 'audited', minWidth: 100, tip: '注册总人数中已审核的人数，也就是老师管理/已审核老师'},
  {title: '培训中', key: 'newTraining', minWidth: 100, tip: '注册总人数中培训中的人数，也就是老师管理/培训中老师'},
  {title: '培训淘汰', key: 'eliminate', minWidth: 110, tip: '注册总人数中培训淘汰的人数'},
  {title: '培训流失', key: 'attrit', minWidth: 110, tip: '注册总人数中培训流失的人数'},
  {title: '在职人数', key: 'openClass', minWidth: 110, tip: '注册总人数中在职的人数，也就是老师管理/在职老师'},
  {title: '离职人数', key: 'resigned', minWidth: 110, tip: '注册总人数中离职的人数，也就是老师管理/离职老师'},
  {title: '已禁用', key: 'disabled', minWidth: 100, tip: '注册总人数中账号禁用的人数'}
]

const DETAIL_EXTRA = {
  pending: {time: '变更时间', operator: '操作人'},
  audited: {time: '审核时间', operator: '审核人'},
  newTraining: {time: '进入培训时间', operator: '操作人'},
  eliminate: {time: '淘汰时间', operator: '操作人'},
  attrit: {time: '流失时间', operator: '操作人'},
  openClass: {time: '开课时间', operator: '操作人'},
  resigned: {time: '离职时间', operator: '操作人'},
  disabled: {time: '禁用时间', operator: '操作人'}
}

import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  name: 'TchRecruitTrainStat',
  data () {
    let today = this.$moment().format('YYYY-MM-DD')
    return {
      rankScoreSeq: 0,
      searchLoading: false,
      tableLoading: false,
      exportLoading: false,
      dateRange: [today, today],
      startDate: today,
      endDate: today,
      hr: '',
      statTemplate: 'default',
      summaryColumns: [],
      channelColumns: [],
      summaryData: [],
      channelData: [],
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detailColumns: [],
      detailData: [],
      detailTotal: 0,
      detailPageIndex: 1,
      detailPageSize: 20,
      detailColumn: '',
      detailChannelScope: 'all',
      detailChannel: '',
      detailReqId: 0,
      channelTableHeight: null
    }
  },
  created () {
    this.summaryColumns = [
      {title: '日期', key: 'period', align: 'center', minWidth: 180}
    ].concat(this.buildStatColumns('all'))
    this.channelColumns = [
      {title: '日期', key: 'period', align: 'center', minWidth: 180},
      {title: '注册渠道', key: 'channel', align: 'center', minWidth: 140}
    ].concat(this.buildStatColumns('channel'))
  },
  mounted () {
    this.onResize = () => {
      this.updateChannelTableHeight()
    }
    window.addEventListener('resize', this.onResize)
    this.search()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    channelTableData () {
      const rows = this.channelData || []
      if (!rows.length) {
        return []
      }
      const summary = {_summary: true, channel: '合计'}
      let period = rows[0] && rows[0].period
      if (period == null || period === '') {
        const s0 = this.summaryData && this.summaryData[0]
        period = s0 && s0.period
      }
      if (period == null || period === '') {
        period = (this.startDate || '') + ' ~ ' + (this.endDate || '')
      }
      summary.period = period
      STAT_COLUMNS.forEach(function (item) {
        let sum = 0
        for (let i = 0; i < rows.length; i++) {
          const v = rows[i][item.key]
          sum += v == null ? 0 : (Number(v) || 0)
        }
        summary[item.key] = sum
      })
      return rows.concat([summary])
    }
  },
  watch: {
    channelTableData () {
      this.updateChannelTableHeight()
    }
  },
  methods: {
    channelRowClassName (row) {
      return row && row._summary ? 'channel-summary-row' : ''
    },
    updateChannelTableHeight () {
      this.$nextTick(() => {
        const table = this.$refs.channelTable
        if (!table || !table.$el) {
          return
        }
        const el = table.$el
        const main = document.querySelector('.layout-content-main')
        const mainBottom = main ? main.getBoundingClientRect().bottom : window.innerHeight
        const visibleBottom = Math.min(mainBottom, window.innerHeight)
        const available = Math.floor(visibleBottom - el.getBoundingClientRect().top - 64)
        const header = el.querySelector('.ivu-table-header')
        const rows = el.querySelectorAll('.ivu-table-tbody tr')
        let content = header ? header.offsetHeight : 40
        for (let i = 0; i < rows.length; i++) {
          content += rows[i].offsetHeight || 48
        }
        if (!rows.length) {
          content += 48
        }
        const next = content > available && available > 80 ? available : null
        if (next !== this.channelTableHeight) {
          this.channelTableHeight = next
        }
      })
    },
    loadMonthRankScores () {
      const table = this.detailData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

    buildStatColumns (channelScope) {
      let self = this
      return STAT_COLUMNS.map(function (item) {
        let column = {
          title: item.title,
          key: item.key,
          align: 'center',
          minWidth: item.minWidth,
          render: function (h, params) {
            let value = params.row[item.key]
            let count = value == null ? 0 : Number(value)
            let text = value == null ? '0' : String(value)
            if (!count) {
              return h('span', text)
            }
            return h('span', {
              style: {color: '#2d8cf0', cursor: 'pointer'},
              on: {
                click: function (e) {
                  e.stopPropagation()
                  const scope = params.row && params.row._summary ? 'all' : channelScope
                  self.openDetail(params.row, item.key, scope)
                }
              }
            }, text)
          }
        }
        if (!item.tip) {
          return column
        }
        column.renderHeader = function (h) {
          return h('span', {class: 'col-head'}, [
            h('span', item.title),
            h('Poptip', {
              props: {
                trigger: 'click',
                content: item.tip,
                placement: 'top',
                transfer: true,
                width: 260
              }
            }, [
              h('Icon', {
                class: 'col-help-icon',
                props: {type: 'help-circled'}
              })
            ])
          ])
        }
        return column
      })
    },
    onDateRangeChange (value) {
      let start = value && value[0]
      let end = value && value[1]
      if (!start || !end) {
        let today = this.$moment().format('YYYY-MM-DD')
        start = today
        end = today
      }
      this.startDate = start
      this.endDate = end
      this.dateRange = [start, end]
      this.search()
    },
    onHrChange (value) {
      this.hr = value || ''
      this.search()
    },
    onStatTemplateChange (value) {
      this.statTemplate = value || 'default'
      this.search()
    },
    queryBody () {
      let body = {
        startDate: this.startDate,
        endDate: this.endDate,
        template: this.statTemplate || 'default'
      }
      if (this.hr) {
        body.hr = this.hr
      }
      return body
    },
    search () {
      this.searchLoading = true
      this.tableLoading = true
      this.$http.post('/tch/recruit-train-stat', this.queryBody()).then((res) => {
        if (res && res.status === 'ok') {
          const data = res.data || {}
          this.summaryData = data.summary || []
          this.channelData = data.channels || []
        } else {
          this.summaryData = []
          this.channelData = []
        }
      }).catch(() => {
        this.summaryData = []
        this.channelData = []
      }).finally(() => {
        this.searchLoading = false
        this.tableLoading = false
        this.updateChannelTableHeight()
      })
    },
    exportData () {
      this.exportLoading = true
      this.$http.post('/tch/recruit-train-stat-export', this.queryBody(), {responseType: 'blob'}).then((response) => {
        const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '招聘培训统计.xlsx'
        link.click()
        this.$Message.success('导出成功')
      }).catch((error) => {
        this.$Message.error('导出失败：' + (error.message || '未知错误'))
      }).finally(() => {
        this.exportLoading = false
      })
    },
    openDetail (row, column, channelScope) {
      this.detailColumn = column
      this.detailChannelScope = channelScope
      if (channelScope === 'channel') {
        this.detailChannel = row.channelParam == null ? '' : row.channelParam
      } else {
        this.detailChannel = ''
      }
      this.detailPageIndex = 1
      this.detailTitle = this.detailTitleOf(row, column, channelScope)
      this.detailColumns = this.buildDetailColumns(column)
      this.detailData = []
      this.detailTotal = 0
      this.detailVisible = true
      this.loadDetail()
    },
    detailTitleOf (row, column, channelScope) {
      let stat = STAT_COLUMNS.find(function (item) {
        return item.key === column
      })
      let name = stat ? stat.title : ''
      let period = row.period == null ? '' : row.period
      let title = name + '明细 · ' + period
      if (channelScope === 'channel') {
        let channelName = row.channel == null ? '' : row.channel
        title += ' · ' + channelName
      }
      return title
    },
    buildDetailColumns (column) {
      let columns = [
        {title: '注册时间', key: 'registerTime', align: 'center', minWidth: 170},
        {title: '老师ID', key: 'tchId', align: 'center', minWidth: 100},
        {
          title: '姓名',
          key: 'name',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.name,
              score: row.monthRankScore
            })
          }
        }
      ]
      let extra = DETAIL_EXTRA[column]
      if (extra) {
        columns.push({title: extra.time, key: 'changeTime', align: 'center', minWidth: 170})
        columns.push({title: extra.operator, key: 'operatorName', align: 'center', minWidth: 120})
      }
      return columns
    },
    detailBody () {
      let body = this.queryBody()
      body.channelScope = this.detailChannelScope
      body.column = this.detailColumn
      body.pageIndex = this.detailPageIndex
      body.pageSize = this.detailPageSize
      if (this.detailChannelScope === 'channel') {
        body.channel = this.detailChannel == null ? '' : this.detailChannel
      }
      return body
    },
    loadDetail () {
      let reqId = ++this.detailReqId
      this.detailLoading = true
      this.$http.post('/tch/recruit-train-stat-detail', this.detailBody()).then((res) => {
        if (reqId !== this.detailReqId) {
          return
        }
        if (res && res.status === 'ok') {
          const data = res.data || {}
          this.detailData = data.data || []
          this.loadMonthRankScores()
          this.detailTotal = data.totalCount || 0
        } else {
          this.detailData = []
          this.detailTotal = 0
          this.$Message.error((res && res.msg) || '明细加载失败')
        }
      }).catch((error) => {
        if (reqId !== this.detailReqId) {
          return
        }
        this.detailData = []
        this.detailTotal = 0
        this.$Message.error('明细加载失败：' + ((error && error.message) || '未知错误'))
      }).finally(() => {
        if (reqId === this.detailReqId) {
          this.detailLoading = false
        }
      })
    },
    onDetailPageChange (page) {
      if (page === this.detailPageIndex) {
        return
      }
      this.detailPageIndex = page
      this.loadDetail()
    },
    onDetailPageSizeChange (size) {
      this.detailPageSize = size
      this.detailPageIndex = 1
      this.loadDetail()
    }
  }
}
</script>

<style scoped>
.list.recruit-train-stat-page { padding: 20px; overflow-x: hidden; }
.breadcrumb { margin-bottom: 20px; }
.search { background: #f8f8f9; padding: 20px; margin-bottom: 20px; border-radius: 4px; }
.stat-toolbar { display: flex; align-items: center; flex-wrap: wrap; }
.hr-label { margin-left: 12px; margin-right: 8px; }
.table-container { background: #fff; padding: 20px; border-radius: 4px; overflow-x: hidden; }
.table-container + .table-container { margin-top: 20px; }
.table-title { margin-bottom: 12px; font-size: 14px; font-weight: 600; }
.stat-formula { margin-bottom: 8px; font-size: 12px; font-weight: 400; color: #808695; }
.col-head { display: inline-flex; align-items: center; justify-content: center; }
.col-help-icon { margin-left: 4px; font-size: 14px; color: #c5c8ce; cursor: pointer; }
.col-help-icon:hover { color: #808695; }
.detail-page { margin-top: 12px; text-align: right; }
>>> .channel-summary-row td { font-weight: 700; }
</style>



// WEBPACK FOOTER //
// TchRecruitTrainStat.vue?29a805c2